import { Component } from '@angular/core';
import { BaseModalDirective } from '../base-modal';

@Component({
    selector: 'nh-doc-upload-limit',
    templateUrl: './doc-upload-limit.component.html',
    styleUrls: ['./doc-upload-limit.component.scss'],
    standalone: false
})
export class DocUploadLimitComponent extends BaseModalDirective{

}
